import { AUTH_TOKEN_NAME } from "@/globals";
import { getCookie } from "./cookie";

export function authToken() {
  return getCookie(AUTH_TOKEN_NAME);
}
